import { addAction as addNRAction, addError as addNRError } from '@shared/utils/logger';

const logToConsole = new URLSearchParams(typeof window !== 'undefined' ? window.location.search.toLowerCase() : '').has('healthlogging');

export function addError(error: unknown, context?: object): void {
  if (logToConsole) {
    console.error(error, context);
  }

  addNRError(error, context);
}

export function addAction(name: string, context?: object): void {
  if (logToConsole) {
    // eslint-disable-next-line no-console
    console.log('[ComponentHealth]', name, context);
  }

  addNRAction(name, context);
}
